import { render } from "./UserView.vue?vue&type=template&id=e3c85fd0&scoped=true"
import script from "./UserView.vue?vue&type=script&lang=js"
export * from "./UserView.vue?vue&type=script&lang=js"

import "./UserView.vue?vue&type=style&index=0&id=e3c85fd0&scoped=true&lang=css"

import exportComponent from "E:\\Projects\\webDesign\\trello-app\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e3c85fd0"]])

export default __exports__